import React from 'react'

const AgentLoginIcon = () => {
  return (
    <svg width="21" height="18" viewBox="0 0 21 18" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M19.5 9.22C19.5 3.73 15.24 0 10.5 0C5.81 0 1.5 3.65 1.5 9.28C0.9 9.62 0.5 10.26 0.5 11V13C0.5 14.1 1.4 15 2.5 15H3.5V8.9C3.5 5.03 6.63 1.9 10.5 1.9C14.37 1.9 17.5 5.03 17.5 8.9V16H9.5V18H17.5C18.6 18 19.5 17.1 19.5 16V14.78C20.09 14.47 20.5 13.86 20.5 13.14V10.84C20.5 10.14 20.09 9.53 19.5 9.22Z"
        fill="#373843"
      />
      <path
        d="M7.5 11C8.05228 11 8.5 10.5523 8.5 10C8.5 9.44772 8.05228 9 7.5 9C6.94772 9 6.5 9.44772 6.5 10C6.5 10.5523 6.94772 11 7.5 11Z"
        fill="#373843"
      />
      <path
        d="M13.5 11C14.0523 11 14.5 10.5523 14.5 10C14.5 9.44772 14.0523 9 13.5 9C12.9477 9 12.5 9.44772 12.5 10C12.5 10.5523 12.9477 11 13.5 11Z"
        fill="#373843"
      />
      <path
        d="M16.5005 8.03C16.262 6.62414 15.5339 5.34797 14.4449 4.42738C13.3559 3.5068 11.9764 3.00117 10.5505 3C7.52046 3 4.26046 5.51 4.52046 9.45C5.75384 8.94577 6.84317 8.14398 7.69121 7.11621C8.53925 6.08845 9.1196 4.86669 9.38046 3.56C10.6905 6.19 13.3805 8 16.5005 8.03Z"
        fill="#373843"
      />
    </svg>
  )
}

export default AgentLoginIcon
